import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Building2, Menu, X, PlusCircle } from 'lucide-react';
import './Header.css';

const Header = ({ onPostService }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/browse', label: 'Browse Services' },
    { path: '/#categories', label: 'Categories' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Contact Us' }
  ];

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container header-container">
        <Link to="/" className="logo">
          <div className="logo-icon">
            <Building2 size={25} strokeWidth={2} />
          </div>
          <div className="logo-text">
            <div className="logo-name">Travel <span className="logo-accent">B2B</span></div>
            <span className="logo-tagline">HUB</span>
          </div>
        </Link>

        <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            {navLinks.map((link) => (
              <li key={link.path}>
                {link.path.startsWith('/#') ? (
                  <a
                    href={link.path}
                    className={`nav-link ${location.hash === link.path.substring(1) ? 'active' : ''}`}
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link
                    to={link.path}
                    className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                  >
                    {link.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="header-actions">

          <button className="btn btn-primary post-btn" onClick={onPostService}>
            <PlusCircle size={18} />
            <span>Post a Service</span>
          </button>
        </div>

        <button
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setIsMobileMenuOpen(false)}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <ul className="mobile-nav-list">
              {navLinks.map((link) => (
                <li key={link.path}>
                  {link.path.startsWith('/#') ? (
                    <a href={link.path} className="mobile-nav-link">
                      {link.label}
                    </a>
                  ) : (
                    <Link to={link.path} className="mobile-nav-link">
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
            <div className="mobile-menu-actions">

              <button className="btn btn-primary" onClick={() => { onPostService(); setIsMobileMenuOpen(false); }}>
                <PlusCircle size={18} />
                Post a Service
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;

